(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsSecondarySelection', rmsSecondarySelection);

    function rmsSecondarySelection() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                primaryModel: '=',
                primaryChanged: '=',
            },
            require: 'ngModel',
            controller: rmsSecondarySelectionCtrl,
            templateUrl: 'common/app/components/secondary-selection',
            link: function(scope, elem, attr, ctrl) {
                scope.refresh = refresh;
                scope.ngModelCtrl = ctrl;

                ctrl.$render = function() {
                    scope.scopeModel.selected = ctrl.$viewValue;
                }

                function refresh() {
                    console.log(scope.getData());
                }
            }
        };
    }

    function rmsSecondarySelectionCtrl(lodash, $timeout, $scope, GenericModel) {
        var primary_select_id = 'primary_select_id';

        this.$onInit = function() {
            $scope.scopeModel = {
                sources: [],
                data: [],
                selected: [],
            };

            if (!$scope.options.name) {
                $scope.options.name = 'secondary-selection-' + $scope.$id;
            }

            primary_select_id = lodash.get($scope.options, 'primary_select_id', 'primary_select_id');

            refreshModel();

            $scope.primaryChanged = primaryChanged;
            $scope.events = {
                selectOnLoad: selectOnLoad,
                selectionChanged: selectionChanged,
                primaryOnLoad: primaryOnLoad,
            }
        }

        function primaryChanged() {
            console.log('primaryChanged');
            primaryOnLoad();
            selectionChanged();
            selectOnLoad();
        }

        function primaryOnLoad() {
            $scope.scopeModel.data = $scope.scopeModel.sources.filter(function(_item) {
                return lodash.filter($scope.primaryModel, {select_id: _item[primary_select_id]}).length > 0;
            });
        }

        function selectionChanged() {
            $scope.scopeModel.selected = $scope.scopeModel.data.reduce(function(result, item) {
               if (item.selected) {
                   result.push({id: item.id, select_id: item.select_id});
               }
               return result;
            }, []);
            $scope.ngModelCtrl.$setViewValue($scope.scopeModel.selected);
        }

        function selectOnLoad() {
            $timeout(function() {
                $scope.scopeModel.data.map(function(item) {
                    if (lodash.filter($scope.scopeModel.selected, {select_id: item.select_id}).length > 0) {
                        item.selected = true;
                    }
                    return item;
                });
            });

        }

        function refreshModel() {
            const url = lodash.get($scope.options, 'datasource.url', '');
            const method = lodash.get($scope.options, 'datasource.method', 'get');
            const params = lodash.get($scope.options, 'datasource.params', {})
            const model = new GenericModel(url);

            model[method](params).$promise.then(function (res) {
                var dataSchema = lodash.get($scope.options, 'datasource.schema.data', 'data');
                $scope.scopeModel.sources = lodash.get(res, dataSchema, []);
                primaryOnLoad();
                selectOnLoad();
            }, function (res) {
            });
        }
        

    }
})();